<template>
  <Modal
    v-model="_value"
    width="600"
    title="第三方监控续费确认收款"
    @on-visible-change="visibleChange"
    ok-text="确认"
    @on-ok="onOk">

    <Form v-if="orderList.length > 0" ref="loginForm" :model="monitoringservice" :label-width="90">
      <div v-for="item in orderList">
        <FormItem prop="registrationNum" label="车牌号">
          <label style="display: inline-block; width: 100px;">{{item.vehicleInfo != null ? item.vehicleInfo.registrationNum : item.vehicleInfo.vin}}</label>
          <label style="display: inline-block;">旧到费期：{{item.oldServiceDatetime != null ? new Date(item.oldServiceDatetime).Format('yyyy年MM月dd日') : "无"}}</label>
          <br>
          <label style="display: inline-block; width: 100px;">金额：{{item.totalAmount}}</label>
          <label style="display: inline-block;">到费日期：{{item.serviceDatetime != null ? new Date(item.serviceDatetime).Format('yyyy年MM月dd日') : "无"}}</label>
        </FormItem>
      </div>

        <FormItem prop="state" label="收款结果">
          <Select style="width: 100px;" v-model="orderListstepstate">
            <Option v-for="item in stepstateOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="result" label="不通过原因" v-if="orderListstepstate == 3">
          <Input style="display: inline-block; width: 400px;" type="textarea" v-model="orderListstepresult"
                 placeholder="不通过原因">
          </Input>
        </FormItem>
<!--        <FormItem prop="serviceDatetime" label="服务到期日期" v-if="orderListstepstate == 2">-->
<!--          <DatePicker type="date" style="width: 100%;" v-model="monitoringservice.serviceDatetime" disabledDate readonly="true"-->
<!--                      placeholder="选择日期"></DatePicker>-->
<!--        </FormItem>-->
        <FormItem prop="receptDatetime" label="收款日期" v-if="orderListstepstate == 2">
          <DatePicker type="date" style="width: 100%;" v-model="monitoringservice.receptDatetime"
                      placeholder="选择日期"></DatePicker>
        </FormItem>
<!--        <FormItem prop="totalAmount" label="单独订单金额" v-if="orderListstepstate == 2">-->
<!--          <InputNumber :min="0" style="width: 100%;" v-model="monitoringservice.totalAmount" readonly="true"-->
<!--                       placeholder="请输入总金额">-->
<!--          </InputNumber>-->
<!--        </FormItem>-->

    </Form>

    <Form v-else ref="loginForm" :model="monitoringservice" :label-width="90">
      <FormItem prop="registrationNum" label="车牌号">
        <label style="display: inline-block; width: 100px;">{{monitoringservice.vehicleInfo.registrationNum}}</label>
      </FormItem>
      <div v-if="monitoringservice.step != null">
      <FormItem prop="state" label="收款结果">
        <Select style="width: 100px;" v-model="monitoringservice.step.state">
          <Option v-for="item in stepstateOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="result" label="不通过原因" v-if="monitoringservice.step.state == 3">
        <Input style="display: inline-block; width: 400px;" type="textarea" v-model="monitoringservice.step.result"
               placeholder="不通过原因">
        </Input>
      </FormItem>
      <FormItem prop="serviceDatetime" label="服务到期日期" v-if="monitoringservice.step.state == 2">
        <DatePicker type="date" style="width: 100%;" v-model="monitoringservice.serviceDatetime" disabledDate
                    placeholder="选择日期"></DatePicker>
      </FormItem>
      <FormItem prop="receptDatetime" label="收款日期" v-if="monitoringservice.step.state == 2">
        <DatePicker type="date" style="width: 100%;" v-model="monitoringservice.receptDatetime"
                    placeholder="选择日期"></DatePicker>
      </FormItem>
      <FormItem prop="totalAmount" label="总金额" v-if="monitoringservice.step.state == 2">
        <InputNumber :min="0" style="width: 100%;" v-model="monitoringservice.totalAmount" readonly
                     placeholder="请输入总金额">
        </InputNumber>
      </FormItem>
      </div>
      <div v-else>
        <FormItem prop="serviceDatetime" label="服务到期日期">
          <DatePicker type="date" style="width: 100%;" v-model="monitoringservice.serviceDatetime" disabledDate
                      placeholder="选择日期"></DatePicker>
        </FormItem>
        <FormItem prop="receptDatetime" label="收款日期">
          <DatePicker type="date" style="width: 100%;" v-model="monitoringservice.receptDatetime"
                      placeholder="选择日期"></DatePicker>
        </FormItem>
        <FormItem prop="totalAmount" label="总金额">
          <InputNumber :min="0" style="width: 100%;" v-model="monitoringservice.totalAmount" readonly
                       placeholder="请输入总金额">
          </InputNumber>
        </FormItem>
      </div>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'monitoringserviceconfirmreceptmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    listValue: null
  },
  data () {
    return {
      stepstateOptions: [
        { label: '通过', value: 2 },
        { label: '不通过', value: 3 }
      ],
      monitoringservice: {
        totalAmount: null,
        lastTotalAmount: null,
        oldServiceDatetime: null,
        receptDatetime: null,
        serviceDatetime: null,
        businessUserId: null,
        businessUser: null,
        receptUserId: null,
        receptUser: null,
        vehicleInfoId: null,
        vehicleInfo: {
          customName: null,
          registrationNum: null,
          registrationColor: null,
          vin: null,
          bodyColor: null,
          vehicleType: {
            id: null,
            name: null
          },
          vehicleBrand: {
            id: null,
            name: null
          },
          engineNum: null,
          vehicleLicenseNum: null,
          unladenMass: null,
          approvedLoad: null,
          vehicleOwnerInfoId: null,
          servicePassword: null,
          vehicleLicenseDistributeDatetime: null,
          vehicleLicenseReigsterDatetime: null,
          remark: null,
          certificateNum: null,
          certificateDistributeDatetime: null,
          vehicleModel: {
            id: null,
            name: null
          },
          chassisModel: null,
          chassisId: null,
          chassisCertificateNum: null,
          engineModel: null,
          energyType: null,
          displacement: null,
          power: null,
          energyUsage: null,
          emissionStandard: null,
          manufacturer: null,
          outlineSizeLong: null,
          outlineSizeWidth: null,
          outlineSizeHeight: null,
          boxSizeLong: null,
          boxSizeWidth: null,
          boxSizeHeight: null,
          springPieceCount: null,
          tyreCount: null,
          tyreSpec: null,
          wheelSpanFront: null,
          wheelSpanBack: null,
          wheelBase: null,
          axisLoad: null,
          axisCount: null,
          turnType: null,
          totalMass: null,
          approvedLoadCoefficient: null,
          towMax: null,
          saddleMax: null,
          cabPeopleCount: null,
          mannedCount: null,
          speedMax: null,
          productionDatetime: null,
          certificateRemark: null,
          vehicleLicensePictureId: null,
          certificatePictureId: null,
          vehicleSrcLicensePicture1Id: null,
          vehicleSrcLicensePicture2Id: null,
          vehicleBodyPictureId: null,
          vehicleUse: null,
          attention: false,
          mliftainsuranceChannelId: null,
          mliftainsurancechannelDatetime: null,
          tiinsuranceChannelId: null,
          tiinsurancechannelDatetime: null,
          insured: null
        },
        positioningDeviceInfos: null,
        updateDatetime: null,
        remark: null,
        billType: null,
        monitoringServicePackage: null,
        urgent: '否',
        receptDatetime: '否',
        stepId: null,
        step: {
          orderId: null,
          state: null,
          lastState: null,
          userId: null,
          user: null,
          result: null
        }
      },

      orderList: [],
      orderIds: [],
      orderListstepstate: null,
      orderListstepresult: null

    }
  },
  methods: {
    ...mapActions([
      'MonitoringServiceServ_ConfirmRecept',
      'MonitoringServiceServ_GetDetail'
    ]),
    onOk () {
      if (this.orderList != null && this.orderList.length > 0) {
        store.dispatch('MonitoringServiceServ_BatchConfirmRecept', {
          params:
              {
                orderList: this.orderIds,
                state: this.orderListstepstate,
                result: this.orderListstepresult,
                receptDatetime: new Date(this.monitoringservice.receptDatetime).Format('yyyy-MM-dd hh:mm:ss')
              },
          urlparams: null
        }).then(() => {
          this.$Message.success('确认成功')
          this.$emit('on-success')
        }).catch((err) => {
          this.$Message.error(err)
          this.$emit('on-fail')
        })
      } else {
        this.$Modal.confirm({
          title: '确认收款',
          content: '<p>注意：确认收款后不能恢复未收款状态</p>',
          onOk: () => {
            store.dispatch('MonitoringServiceServ_ConfirmRecept', { params: this.monitoringservice }).then(() => {
              this.$Message.success('确认成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          },
          onCancel: () => {
          }
        })
      }
    },
    visibleChange (val) {
      if (val) {
        this.orderList = this._listValue
        this.orderIds = []
        // console.log(this.orderList)
        if (this.orderList != null && this.orderList.length > 0) {
          this.orderList.forEach(item => {
            this.orderIds.push(item.id)
          })
          this.monitoringservice.receptDatetime = new Date()
          this.orderListstepstate = 2
        } else {
          this.orderIds = []

          this.monitoringservice.id = null
          this.monitoringservice.receptDatetime = null

          let monitoringserviceId = this._initValue
          if (monitoringserviceId) {
            store.dispatch('MonitoringServiceServ_GetDetail', {
              params: { id: monitoringserviceId }
            }).then(() => {
              this.monitoringservice = store.getters.get_MonitoringService_GetDetailResult
              this.monitoringservice.serviceDatetime = new Date(this.monitoringservice.serviceDatetime)
              this.monitoringservice.receptDatetime = new Date()
              if (this.monitoringservice.step) {
                this.monitoringservice.step.state = 2
              }
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _listValue: {
      get () {
        return this.listValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
